// UNKNOWN_OPEN_STATUS_V1
// Shared presentation rules for venue hours and addresses.
//
// Important: missing opening-hours data is not the same as "closed".

const ADDRESS_PLACEHOLDER_RE =
  /^(?:address\s+(?:unavailable|not\s+available|unknown)|no\s+address(?:\s+available)?|unknown\s+address|n\/?a|null|undefined|-|—)$/i;

function firstExplicitBoolean(values) {
  for (const value of values) {
    if (value === true || value === false) return value;
  }
  return null;
}

export function getVenueHoursState(venue = null) {
  const explicitOpen = firstExplicitBoolean([
    venue?.current_opening_hours?.open_now,
    venue?.opening_hours?.open_now,
    venue?.open_now,
    venue?.openNow,
    venue?.isOpen,
  ]);

  const statusText = String(
    venue?.openStatus ||
      venue?.open_status ||
      venue?.status ||
      ''
  )
    .trim()
    .toLowerCase();

  const businessStatus = String(venue?.business_status || '')
    .trim()
    .toUpperCase();

  if (
    explicitOpen === true ||
    statusText === 'open' ||
    statusText === 'open_now' ||
    statusText === 'open now'
  ) {
    return {
      key: 'open',
      label: 'Open now',
      className: 'open',
      badgeClassName: 'open',
    };
  }

  if (
    explicitOpen === false ||
    statusText === 'closed' ||
    statusText === 'closed_now' ||
    statusText === 'closed now' ||
    statusText === 'open_soon' ||
    statusText === 'open soon' ||
    statusText.includes('closed_temporarily') ||
    statusText.includes('closed_permanently') ||
    businessStatus === 'CLOSED_TEMPORARILY' ||
    businessStatus === 'CLOSED_PERMANENTLY'
  ) {
    return {
      key: 'closed',
      label: 'Closed now',
      className: 'closed',
      badgeClassName: 'closed',
    };
  }

  return {
    key: 'unknown',
    label: 'Hours unavailable',
    className: 'hours-unavailable',
    badgeClassName: 'unknown',
  };
}

export function getUsableVenueAddress(venue = null) {
  const candidates = [
    venue?.vicinity,
    venue?.formatted_address,
    venue?.formattedAddress,
    venue?.address,
    venue?.location?.address,
  ];

  for (const candidate of candidates) {
    const value = String(candidate || '').trim();

    if (!value) continue;
    if (ADDRESS_PLACEHOLDER_RE.test(value)) continue;

    return value;
  }

  return '';
}
